module.exports = __webpack_public_path__ + "media/images/nav_social/nav_facebook-b90187a663087373eb2b9b2278618944.svg";